import { twMerge } from 'tailwind-merge';

export default function Switch({ label, className, labelClassName, ...props }) {
  return (
    <div
      className={twMerge('flex items-center justify-between gap-3', className)}
    >
      {label && (
        <label className={twMerge('font-medium text-gray-900', labelClassName)}>
          {label}
        </label>
      )}
      <div className="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 outline-offset-2 outline-indigo-600 ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-indigo-600 has-[:focus-visible]:outline has-[:focus-visible]:outline-2 dark:bg-white/5 dark:outline-indigo-500 dark:ring-white/10 dark:has-[:checked]:bg-indigo-500">
        <span className="size-5 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-5" />
        <input
          type="checkbox"
          className="absolute inset-0 appearance-none focus:outline-none"
          {...props}
        />
      </div>
    </div>
  );
}
